import { LocationQuery } from 'vue-router';

import { StoreState } from '@/core/models/store.interface';
import { Module } from 'vuex';
import { JobFunctionService } from './job-function.service';

const service = new JobFunctionService();

export interface JobFunctionState {}

const JobFunctionStore: Module<JobFunctionState, StoreState> = {
   namespaced: true,
   state: {},
   getters: {},
   mutations: {},
   actions: {
      async searchJobFunctions(context, query?: LocationQuery) {
         return await service.getJobFunctions({ page: '1', per_page: '25', ...query });
      },
      async getJobFunction(context, payload: { jobFunctionId: number; query?: LocationQuery }) {
         const response = await service.getJobFunction(payload.jobFunctionId, payload.query);
         return response.data;
      },
   },
};

export default JobFunctionStore;
